import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  DialogActions,
  Button,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import theme from 'theme'

const DialogCancelDpoAlert = ({
  open = false,
  handleClose = () => {},
  handleSubmit = () => {},
}) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle>
        <Box>
          <Typography variant="h4">
            Tem certeza que deseja remover o Encarregado de Proteção de
            Dados(DPO) responsável?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
          <Alert severity="warning">
            Essa ação removerá o Encarregado de Proteção de Dados (DPO)
            responsável, com implicações significativas para a empresa, e&nbsp;
            <strong>
              arquivará automaticamente os projetos de governança vinculados ao
              grupo advisor de origem!
            </strong>
          </Alert>

          <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
            <Typography>
              A nomeação de um novo Encarregado de Proteção de Dados(DPO) está
              atrelada à requisitos legais, afetando a responsabilidade perante
              à LGPD e a ANPD, o relacionamento com diretoria e líderes, as
              avaliações de riscos de dados e a revisão de políticas de
              privacidade.
            </Typography>
            <Typography>
              Seus titulares de dados não receberão respostas, e seus incidentes
              estarão sem nenhum tratamento. Sua organização não atenderá aos
              requisitos fundamentais da LGPD.
            </Typography>
            <Typography>
              Caso a sua organização não possua um Encarregado de Proteção de
              Dados (DPO) nomeado, estará exposta a riscos.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          justifyContent="flex-end"
          width="100%"
          gridGap={theme.spacing(2)}
        >
          <Button color="primary" variant="outlined" onClick={handleClose}>
            CANCELAR
          </Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>
            CONFIRMAR
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default DialogCancelDpoAlert
